import ListItem from '../utils/ListItem';

function GroupsListItem(props) {
  return (
    <ListItem
      to={props.link}
      primary={props.name}
      secondary={props.groupType}
    />
  );
}

export default GroupsListItem;
